import { Params } from "@angular/router";
import { Component, ElementRef } from "@angular/core";

import { BaseWidget } from "../../BaseWidget/BaseWidget.component";

import { UserStatistics, WidgetPreferences } from "../../../../interfaces/UserInterfaces";
import { UtilityFunctions } from "../../../../classes/UtilityFunctions";
import { DisplayStateService } from '../../../../services/DisplayStateService';
import { AppStateService } from '../../../../services/AppStateService';
import { WebPlatformApiService } from '../../../../services/WebPlatformApiService';
import { ClientSettingsService } from '../../../../services/ClientSettingsService';

@Component({
  selector: 'app-user-widget-prefs',
  template: `<div *ngIf="!minimumVersionProblem; else minVersionProblem" class="container-fluid">

  <div class="row">
    <div class="col-md-3">

      <div class="card">
        <div class="card-header">
          <h5 class="m-0">Users</h5>
          <input type="text" class="form-control mb-3" [ngModel]="userFilter" (ngModelChange)="onLocalUserFilterChange($event)" placeholder="Search"
          />
        </div>

        <ul *ngIf="filteredUserStatisticsList; else loading" class="list-group scrollable-list">
          <li *ngFor="let userStats of filteredUserStatisticsList; let idx = index" (click)="UserSelect(userStats)" class="list-group-item justify-content-between {{IsUserActive(userStats)}}">

            <span class="float-sm-left">{{userStats.userName}} </span>

          </li>
        </ul>
      </div>
    </div>

    <div class="col-md-3">
      <div *ngIf="selectedUserStatistics" class="card">
        <div class="card-header">
          <h5 class="m-0">widget preference list: {{selectedUserStatistics.userName}}</h5>
          <input type="text" class="form-control mb-3" [ngModel]="preferencesFilter" (ngModelChange)="onLocalPreferencesFilterChange($event)"
            placeholder="Search" />
        </div>

        <ul *ngIf="filteredPreferencesList"  class="list-group scrollable-list">
          <li *ngFor="let preferences of filteredPreferencesList; let idx = index" (click)="PreferencesSelect(preferences)" class="list-group-item justify-content-between {{IsPreferencesActive(preferences)}}">

            <span class="float-sm-left">{{preferences.uniqueWidgetKey}} </span>

          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h5 *ngIf="selectedPreferences" class="m-0">{{selectedPreferences.uniqueWidgetKey}} </h5>
        </div>

        <div *ngIf="JsonData">
          <button [disabled]="!canEditSettings" type="button" class="btn btn-info btn-sm" (click)="UpdatePreferencesJson()">
            Save Config Changes
          </button>
          <textarea [disabled]="!canEditSettings" style="width: 100%; height: 400px" [(ngModel)]="JsonData" name="JsonData"></textarea>
      </div>
      </div>
    </div>

  </div>
</div>

<ng-template #loading>
  <i class="fa fa-spinner fa-spin"></i> Loading data...
</ng-template>

<ng-template #minVersionProblem>
    <div class="card">
        <div class="card-header">
          <h3>Middle layer API version compatility issue</h3>          
        </div>
        <span>{{minimumVersionProblem}}</span>
    </div>
  
</ng-template>`,
  styles: [`.modal-lg{
   max-width:90%;
   max-height:90%;
}

.modal-lg .modal-body{
  overflow-y:auto;
}

.scrollable-list{
  overflow-y:auto;
  height:80vh;
}`]
})
export class UserWidgetPreferencesComponent extends BaseWidget {
  userFilter: string;
  userStatisticsList: UserStatistics[];
  filteredUserStatisticsList: UserStatistics[];
  selectedUserStatistics: UserStatistics;

  preferencesFilter: string;
  preferencesList: WidgetPreferences[];
  filteredPreferencesList: WidgetPreferences[];
  selectedPreferences: WidgetPreferences;
  canEditSettings = false;
  JsonData: string;

  constructor(
    protected element: ElementRef,
    protected clientSettingsService: ClientSettingsService,
    protected displayStateService: DisplayStateService,
    protected appStateService: AppStateService,
    protected webPlatformApiService: WebPlatformApiService) {
      super(element, clientSettingsService, displayStateService, appStateService, webPlatformApiService);
    }
  minimumApiVersion(): number[] { return [1, 1, 2, 0]; }

  onInitialize() {
    if (!this.minimumVersionProblem) {
      this.LoadUsers();
    }
  }

  // LoadUsers -> ApplyUserFilters -> CheckSelectedUserOK -> ApplyPreferenceFilters -> CheckSelectedPreferencesOK

  LoadUsers() {
    this.webPlatformApiService.GetMongoDocs('User').subscribe(list => {
      this.userStatisticsList = <UserStatistics[]>list;
      this.ApplyUserFilters();

      const currentUserStatsIdx =this.filteredUserStatisticsList
        .findIndex(x => x.userName === this.displayStateService.appState.current.userStatistics.userName)
      if (currentUserStatsIdx > -1)
      this.UserSelect(this.filteredUserStatisticsList[currentUserStatsIdx]);
    });
  }

  ApplyUserFilters() {
    if (this.userFilter && this.userStatisticsList) {
      this.filteredUserStatisticsList = this.userStatisticsList.filter(
        us =>
          us.userName.toLowerCase().indexOf(this.userFilter.toLowerCase()) > -1
      );
      
    } else {
      this.filteredUserStatisticsList = this.userStatisticsList;
    }

    if (this.filteredUserStatisticsList && this.filteredUserStatisticsList.length === 1) {
      if(!this.selectedUserStatistics || this.selectedUserStatistics.userName !== this.filteredUserStatisticsList[0].userName) {
        this.UserSelect(this.filteredUserStatisticsList[0]);
      }      
    }
    this.CheckSelectedUserOK();
  }

  CheckSelectedUserOK() {
    if (this.filteredUserStatisticsList === undefined) {
      this.selectedUserStatistics = undefined;
    } else if (this.selectedUserStatistics) {
      this.selectedUserStatistics = this.filteredUserStatisticsList.find(
        x =>
          this.selectedUserStatistics &&
          x.userName === this.selectedUserStatistics.userName
      );
    }

    this.preferencesList = this.selectedUserStatistics ? this.selectedUserStatistics.widgetPreferences : undefined;

    this.ApplyPreferencesFilters();
  }

  ApplyPreferencesFilters() {

    if (this.preferencesFilter && this.preferencesList) {
      this.filteredPreferencesList = this.preferencesList.filter(
        p => p.uniqueWidgetKey .toLowerCase() .indexOf(this.preferencesFilter.toLowerCase()) > -1
      );
    } else {
      this.filteredPreferencesList = this.preferencesList;
    }

    if (this.filteredPreferencesList && this.filteredPreferencesList.length === 1) {
      if (!this.selectedPreferences || this.selectedPreferences.uniqueWidgetKey !== this.filteredPreferencesList[0].uniqueWidgetKey) {
        this.PreferencesSelect(this.filteredPreferencesList[0]);
      }
      
    }
    this.CheckSelectedPreferencesOK(); 
  }

  CheckSelectedPreferencesOK() {

    if (this.filteredPreferencesList === undefined) {
      this.selectedPreferences = undefined;
    } else if (this.selectedPreferences) {

      this.selectedPreferences = this.filteredPreferencesList.find(
        p =>
          this.selectedPreferences &&
          p.uniqueWidgetKey === this.selectedPreferences.uniqueWidgetKey
      );      
    }

    this.JsonData = this.selectedPreferences ? this.selectedPreferences.preferences : undefined;
  }

  onLocalUserFilterChange(newValue: string) {
    this.userFilter = newValue;
    this.ApplyUserFilters();
  }

  onLocalPreferencesFilterChange(newValue: string) {
    this.preferencesFilter = newValue;
    this.ApplyPreferencesFilters();
  }

  UserSelect(us: UserStatistics) {
    this.selectedUserStatistics = us;
    this.canEditSettings = (us.userName === this.displayStateService.appState.current.userStatistics.userName);
    this.ApplyUserFilters();
  }

  IsUserActive(us: UserStatistics): string {    
    return  this.selectedUserStatistics && this.selectedUserStatistics.userName === us.userName ? "list-group-item-success" : "";
  }

  PreferencesSelect(p: WidgetPreferences) {
    this.selectedPreferences = p;
    this.ApplyPreferencesFilters();
  }

  IsPreferencesActive(p: WidgetPreferences) {
    return  this.selectedPreferences && this.selectedPreferences.uniqueWidgetKey === p.uniqueWidgetKey ? "list-group-item-success" : "";
  }

  UpdatePreferencesJson() {
    if (this.JsonData && this.selectedPreferences) {
      try {
        this.selectedPreferences.preferences = this.JsonData;
        this.displayStateService.appState.current.userStatistics.widgetPreferences = this.preferencesList;
        this.webPlatformApiService
          .UpsertUserStats(this.displayStateService.appState.current.userStatistics)
          .subscribe(x => {
            this.displayStateService.RaiseSuccessToast('Saved User Settings to database.');
          });
      } catch (e) {
        alert(JSON.stringify(e));
      }
    }
  }
}
